module.exports = __webpack_public_path__ + "static/media/BauPro-Medium.c9bc97f7.otf";